// src/components/Navbar.jsx
import React from "react";
import { Link } from "react-router-dom";

export default function Navbar() {
  return (
    <nav className="w-full bg-white shadow-sm sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-6 py-4 flex items-center justify-between">
        <Link to="/" className="text-2xl font-bold text-pink-600">Glow Picks</Link>
        <div className="hidden md:flex gap-8 text-gray-700 font-medium">
          <Link to="/" className="hover:text-pink-600">Home</Link>
       <Link to="/category/all" className="hover:text-pink-600">
  Categories
</Link>



          <Link to="/blog" className="hover:text-pink-600">Blog</Link>
          <Link to="/about" className="hover:text-pink-600">About</Link>
        </div>
       <Link
  to="/category/all"
  className="bg-pink-500 text-white px-5 py-2 rounded-full hover:bg-pink-600 transition"
>
  Explore Picks
</Link>
      </div>
    </nav>
  );
}
